let _guid = 0

export function newGUID () {
  return _guid++
}
